import { useSelectedChain } from "@app/examples/ChainSelector";
import { useBaaanggg } from "@hooks/BaaangggHook";
import { CoinResponse } from "baaanggg";
import { createContext, useContext, useEffect, useState } from "react";

type CoinsContextProps = {
    coins: CoinResponse[],
    getCoin: (identifier: string) => CoinResponse | undefined;
    refreshCoins: () => void
}

export const CoinsContext = createContext<CoinsContextProps>({
    coins: [],
    getCoin: () => undefined,
    refreshCoins: () => undefined
});
export const useCoins = () => useContext(CoinsContext);

export const CoinsContextProvider = ({ children }: { children: React.ReactNode; }) => {
    const [coins, setCoins] = useState<CoinResponse[]>([])
    const { selectedChain } = useSelectedChain()
    const baaanggg = useBaaanggg()

    const getCoin = (identifier: string) => coins.find(coin => coin.denom === identifier || coin.cw20Address == identifier || coin.id == identifier)
    const getCoinById = (id: string) => coins.find(coin => coin.id === id)
    const fetchCoins = async (force: boolean = false) => {
        if (selectedChain && (coins.length === 0 || coins[0]?.chainId !== selectedChain?.id || force)) {
            setCoins(await baaanggg.coin.all({ chainId: selectedChain.id }))

        }
    }

    useEffect(() => {
        fetchCoins()
    }, [selectedChain])

    return (
        <CoinsContext.Provider value={{ coins, getCoin, refreshCoins: () => fetchCoins(true) }}>
            <>{children}</>
        </CoinsContext.Provider>
    );
};